import React from 'react';
import { Box, Text } from '@wix/design-system';
export const PricingTooltip = _ref => {
  let {
    content
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    padding: "SP3 SP4"
  }, typeof content === 'string' ? /*#__PURE__*/React.createElement(Text, {
    size: "small",
    light: true
  }, content) : content);
};
//# sourceMappingURL=PricingTooltip.js.map